<!-- TODO unused since BILL-666-->
<template>
    <div class="page-wrapper">
        <h1>Реквизиты</h1>
        <user-payments-data v-if="userFetched()" v-bind:user="user"/>
    </div>
</template>

<script>
  import { mapState } from 'vuex';

  import UserPaymentsData from "@/UserPaymentsData";

  export default {
    name: "UserPaymentsDataView",
    components: {
      UserPaymentsData
    },
    computed: {
      ...mapState({
        user(state) {
          return state.user.data;
        }
      })
    },
    methods: {
      userFetched() {
        return this.user.id;
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/views/UserPaymentsDataView.vue